export enum AddressType {
    Undefined = "Undefined",
    PartsShipTo = "PartsShipTo",
    Mailing = "Mailing",
}
